import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";

import { WorkflowService } from "../../services/workflow-service";
import { EntityService } from "../../services/entity-service";
import { NotifyService } from "../../services/notify-service";


export class WorkflowController {

    static $inject = ["$window", "entityService", "workflowService", "notifyService"];

    encryptedString: string;
    workflowActions: Models.IWFAction[];
    loading: boolean;
    inValidEncryptedString: boolean;
    validationError: string;
    selectedAction: Models.IWFAction;
    workflowActionCompleted: boolean;
    loadingMessage: string;
    validationResult: Models.IWorkflowValidateEncryptedString;
    newStatus: string;
    userTitle: string;
    charTypeName: string;
    charTypeNames: { [id: number]: string };
    workflowActionSuccessful: boolean;
    selectedActionName: string;
    entityID: string;
    headerTitle: string;
    moduleLevelCharTypeIDs: { [id: string]: number };

    constructor(private $window: ng.IWindowService, private entityService: EntityService, private workflowService: WorkflowService, private notifyService: NotifyService) {
        this.charTypeNames = <{ [id: number]: string }>Consts.CharTypeNames.IDs;
        this.moduleLevelCharTypeIDs = <{ [id: string]: number }>Consts.ModuleLevelCharTypes.IDs;
    }

    Init(encryptedString: string) {
        this.encryptedString = "";
        this.loading = true;
        this.inValidEncryptedString = false;
        this.validationError = "";
        this.encryptedString = encryptedString;
        this.workflowActionCompleted = false;
        this.loadingMessage = "Loading Workflow Actions";
        this.newStatus = "";
        this.userTitle = "";
        this.charTypeName = "";
        this.selectedActionName = "";
        this.entityID = "";
        this.headerTitle = "Take Workflow Action";
        this.GetAvailableWorkflowActions();
    }

    GetAvailableWorkflowActions() {
        if (!_.isEmpty(this.encryptedString)) {

            this.workflowService.validateEncrptedString(this.encryptedString)
                .then((result) => {
                    if (result.success) {
                        this.validationResult = result.data;
                        this.charTypeName = this.charTypeNames[this.validationResult.charTypeID];
                        if (_.isEmpty(result.data.validationResult)) {
                            this.workflowService.getAvailableWorkflowActionsForEncryptedString(this.encryptedString)
                                .then((result) => {
                                    this.workflowActions = result;
                                    this.loading = false;
                                });
                        }
                        else {
                            this.validationError = result.data.validationResult;
                            this.inValidEncryptedString = true;
                            this.loading = false;
                        }
                    }
                    else {
                        this.validationError = "Unexpected Error Occured";
                        this.inValidEncryptedString = true;
                        this.loading = false;
                    }
                });
        }
    }

    ExecuteWorkflowAction() {
        if (this.selectedAction != null) {
            if (this.$window.confirm("Are you sure you want to take this workflow action?")) {
                this.loading = true;
                this.loadingMessage = "Running Workflow Action";
                this.workflowService.executeWorkflowAction(this.encryptedString, this.selectedAction.actionID)
                    .then((result) => {
                        
                        if (_.any(this.moduleLevelCharTypeIDs, (id) => id == this.validationResult.charTypeID)) {
                            this.entityID = Utils.IdBuilder.buildEntityID(this.selectedAction.divisionID, this.validationResult.charTypeID, this.validationResult.recordID);
                        }
                        else {
                            this.entityID = this.validationResult.parentEntityID;
                        }
                        this.workflowActions = [];
                        this.selectedActionName = this.selectedAction.actionName;
                        this.selectedAction = undefined;
                        this.encryptedString = "";
                        this.loading = false;
                        this.workflowActionCompleted = true;
                        if (result.success) {
                            this.userTitle = result.userTitle;
                            this.newStatus = result.newStatusLabel;
                            this.workflowActionSuccessful = true;
                            this.headerTitle = "Workflow Action Successful";
                            this.notifyService.notifySuccess("Workflow Action Successful.");
                        }
                        else {
                            this.workflowActionSuccessful = false;
                            this.headerTitle = "Workflow Action Failed";
                            this.validationError = result.errorStep;
                            this.notifyService.notifyError("Workflow Action Failed.");
                        }
                    });
            }
        }
    }

}